export default __webpack_public_path__ + "static/media/steel.cb91a92a.svg";